import Tooltip from 'builder/components/Tooltip'
import Button, { ButtonTheme } from 'builder/components/Button'
import { useI18n } from 'builder/hooks/useI18n'
import { Icon24 } from 'builder/components/Icon'
import { usePostRedirectUrl } from 'builder/features/futureLearn/hooks/useGetRedirectUrl'

export const TRANSLATION = 'builder.dashboard.learning_hub'

export const UnlimitedLearningButton = (props: { children: React.ReactNode }) => {
  const { i18n } = useI18n()
  const { mutateAndRedirect } = usePostRedirectUrl()

  return (
    <Tooltip
      value={i18n.t(`${TRANSLATION}.actions.nav_bar_tooltip`)}
      position="bottom"
      align="center"
      width={212}
      multiline
    >
      <Button
        onClick={() => mutateAndRedirect({})}
        theme={ButtonTheme.ghost}
        size="small"
        style={{ gap: '8px' }}
      >
        <Icon24.StudyOutlineIcon />
        {props.children}
      </Button>
    </Tooltip>
  )
}
